// extracted by mini-css-extract-plugin
module.exports = {"normal":"Container_normal__2kRGY","large":"Container_large__5uYHZ"};